import React from 'react';
import { CheckCircle, ChevronDown } from 'lucide-react';

const Select = ({ value, onChange, onBlur, options = [], placeholder = 'Select...', className = '', hasError = false }) => {
  return (
    <div className="relative">
      <select
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={`
          w-full px-4 py-3 bg-white border-2 rounded-lg
          focus:ring-2 focus:outline-none
          text-gray-800 shadow-md transition-all
          appearance-none cursor-pointer
          ${hasError
            ? 'border-red-500 focus:ring-red-300 focus:border-red-500'
            : 'border-red-200 focus:ring-red-300 focus:border-red-400 hover:border-red-300'
          }
          ${!value ? 'text-gray-400' : 'text-gray-800'}
          ${className}
        `}
      >
        <option value="" disabled>{placeholder}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {value && !hasError && (
        <div className="absolute right-8 top-1/2 -translate-y-1/2 text-green-500 pointer-events-none">
          <CheckCircle className="w-4 h-4" />
        </div>
      )}
      <div className="absolute right-3 top-1/2 -translate-y-1/2 text-red-400 pointer-events-none">
        <ChevronDown className="w-4 h-4" />
      </div>
    </div>
  );
};

export default Select;